import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface FormPageSkeletonProps {
  fieldCount?: number;
}

export const FormPageSkeleton: React.FC<FormPageSkeletonProps> = ({ fieldCount = 6 }) => (
  <div>
    <Skeleton className="mb-6 h-10 max-w-xs" style={{ width: "40%" }} />
    <Card>
      <CardContent className="space-y-6 p-6">
        {Array.from({ length: fieldCount }).map((_, i) => (
          <div key={i}>
            <Skeleton className="mb-2 h-5 w-28" />
            <Skeleton className="h-10 w-full rounded-md" />
          </div>
        ))}
      </CardContent>
    </Card>
  </div>
);

export default FormPageSkeleton;
